var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base"},[_c('table',{staticClass:"numberBoard",style:({ 'font-size': _vm.fontSize })},_vm._l((9),function(row){return _c('tr',{key:row},_vm._l((10),function(col){return _c('td',{key:col + (row - 1) * 10},[_c('div',{class:{
          specialGold: _vm.getCurrentNumber === col + (row - 1) * 10,
          specialRed:
            _vm.getDrawnNumbers.includes(col + (row - 1) * 10) &&
            _vm.getCurrentNumber !== col + (row - 1) * 10,
        }},[_vm._v(" "+_vm._s(col + (row - 1) * 10)+" ")])])}),0)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }